import { BillStatus } from "@common/types/bill";
import { FiltersTypes } from "@common/types/filters/general";
import { BillColumn } from "@common/types/views/billViews";
import { ViewDensity, ViewType } from "@common/types/views/views";
import { billsCloseTemplateViewConfigSchema } from "@common/schemas/close-template-task-view-config.schema";

/** The statuses the bills page shows by default: everything but void. */
export const DEFAULT_BILLS_TASK_STATUSES = [
    BillStatus.DRAFT,
    BillStatus.OPEN,
    BillStatus.PAID,
];

function billsTaskColumns() {
    return [
        { id: BillColumn.LOCK, options: { pin: "left" as const } },
        { id: BillColumn.DATE, options: { pin: "left" as const } },
        { id: BillColumn.EXTERNAL_STATUS },
        { id: BillColumn.INVOICE_NUMBER },
        { id: BillColumn.VENDOR },
        { id: BillColumn.ACCOUNT },
        { id: BillColumn.DUE_DATE },
        { id: BillColumn.AMOUNT },
        { id: BillColumn.ENTITY, options: { pin: "right" as const } },
        { id: BillColumn.EXTERNAL_LINK, options: { pin: "right" as const } },
    ];
}

export interface CreateBillsTaskViewConfigParams {
    filters?: FiltersTypes;
    columns?: ReturnType<typeof billsTaskColumns>;
}

/**
 * Default view for a BILLS task (template, workspace drawer and bulk
 * selection). Selection and bulk actions are on so the task body can act on
 * rows; the creation preview turns them off locally.
 */
export function createBillsTaskViewConfig({
    filters = { externalBillStatuses: DEFAULT_BILLS_TASK_STATUSES },
    columns,
}: CreateBillsTaskViewConfigParams = {}) {
    return billsCloseTemplateViewConfigSchema.parse({
        type: ViewType.BILL,
        columns: columns ?? billsTaskColumns(),
        filters,
        options: {
            selection: true,
            bulkActions: true,
            density: ViewDensity.MD,
        },
    });
}
